<div *transloco="let t; read: 'profile-list-group-filter'"
  class="filter-section">
  <accredible-themeable-multiple-search-input [label]="t('credentials')"
    [ariaLabel]="t('aria_credentials')"
    [placeholder]="t('search_credentials')"
    [options]="groups$ | async"
    [optionsLabelKey]="'course_name'"
    [selectedOptions]="selectedGroups()"
    [usingStaticOptions]="true"
    (optionsChanged)="onSelectedGroupsChange($event)">
  </accredible-themeable-multiple-search-input>
</div>
